import * as S from './ComplianceSection.styles'

export const ComplianceSection = () => {
  return (
    <S.Wrapper
      id='compliance'
    >
      <S.TextBox>

        <S.TextBoxH2>
          Regulatory Peace of Mind
        </S.TextBoxH2>

        <S.TextBoxP>
          PayQuest is authorized and regulated by the Central Bank of Brazil under Resolution 277. We bring you closer to Brazilian consumers without legal headaches.
        </S.TextBoxP>

      </S.TextBox>

      <S.CardSolo>
        <S.TextCardSolo>
          <S.SpanCardSolo></S.SpanCardSolo>
          KYC & Anti-Fraud
        </S.TextCardSolo>

        <S.TextCardSolo>
          <S.SpanCardSolo></S.SpanCardSolo>
          Consent Verification
        </S.TextCardSolo>

        <S.TextCardSolo>
          <S.SpanCardSolo></S.SpanCardSolo>
          Merchant Content Monitoring
        </S.TextCardSolo>

        <S.TextCardSolo>
          <S.SpanCardSolo></S.SpanCardSolo>
          Full Transactional Reporting
        </S.TextCardSolo>
      </S.CardSolo>
    </S.Wrapper>
  )
}
